import { Trans } from "@lingui/macro";

import { Quarter } from "./Quarter";

export function Quareters() {
  return (
    <div className="flex flex-row gap-0 overflow-x-scroll pt-8 scrollbar-hide">
      <Quarter lastCompleted>
        <Trans>
          <p>Advanced Trading Tools</p>
          <p>Trading Bots</p>
          <p>Copy Trading</p>
        </Trans>
      </Quarter>
      <Quarter>
        <Trans>
          <p>BSC Support</p>
          <p>Base Support</p>
          <p>Avalanche Support</p>
          <p>Polygon Support</p>
        </Trans>
      </Quarter>
      <Quarter>
        <Trans>
          <p>Multichain</p>
          <p>Just-in-Time Liquidity</p>
        </Trans>
      </Quarter>
      <Quarter>
        <Trans>
          <p>Cross-Margin</p>
          <p>Cross-Collateral</p>
        </Trans>
      </Quarter>
      <Quarter>
        <Trans>
          <p>Market Groups</p>
          <p>Net Open Interest</p>
        </Trans>
      </Quarter>
    </div>
  );
}
